import { selectTheme } from "components/CustomerCards/CustomerCardsSearchBar";
import { CUSTOMER_APPLICATION_TYPE_FILTER_OPTIONS, CustomerApplicationType } from "models/customer-application";
import React from "react"
import Select from "react-select";

const selectStyle = {
    indicatorSeparator: () => (
        {
            backgroundColor: 'red',
            width: '50px',
        }
    ),
};

interface CustomerApplicationsSearchBarProps {
  type?: CustomerApplicationType;
  onTypeChange: (type: CustomerApplicationType) => void;
  requestButton?: React.ReactNode;
}

export const CustomerApplicationsSearchBar = (props: CustomerApplicationsSearchBarProps) => {

  const currentOption = props.type ? CUSTOMER_APPLICATION_TYPE_FILTER_OPTIONS.filter(t => t.value === props.type) : null;

  return (
            <>
                <h2>
                    Taotlused
                </h2>
                <div className="customer-applications__search-bar d-flex flex-lg-nowrap align-items-center">
                    <Select
                        options={CUSTOMER_APPLICATION_TYPE_FILTER_OPTIONS}
                        style={selectStyle}
                        value={currentOption}
                        onChange={(val: any) => props.onTypeChange(val?.value)}
                        className='mw-240-px mr-md-4 mr-0 mt-2 mt-md-0 invoices__select'
                        placeholder='Vali tüüp'
                        theme={selectTheme}
                        isClearable
                    />
                    <div className="d-flex ml-auto">
                        { props.requestButton }
                    </div>
                </div>
            </>
        )
}